import { Operation, OperationDirection } from './Transactions.types';
import { INCOME_SERVICE_NAMES } from './Transactions.constants';
import {
  PaymentAd,
  UserPayment,
  UserTransaction,
} from '@/features/Profile/api';

export function getOperationDirection(serviceName: string): OperationDirection {
  return INCOME_SERVICE_NAMES.has(serviceName) ? 'income' : 'expense';
}

function mapAd(ad: PaymentAd | null) {
  if (!ad) {
    return undefined;
  }

  return {
    id: ad.id,
    title: ad.title,
    path: ad.path,
  };
}

export function mapPaymentToOperation(payment: UserPayment): Operation {
  const operationNumber =
    payment.paymentLegacyId?.toString() ?? payment.serviceId;

  return {
    id: operationNumber,
    operationNumber,
    serviceName: payment.displayServiceName,
    amount: Math.abs(payment.amount),
    paymentMethod: payment.paymentMethod,
    date: payment.updatedAt,
    direction: getOperationDirection(payment.displayServiceName),
    ad: mapAd(payment.ad),
  };
}

export function mapTransactionToOperation(
  transaction: UserTransaction
): Operation {
  return {
    id: transaction.serviceId,
    operationNumber: transaction.serviceId,
    serviceName: transaction.displayServiceName,
    amount: Math.abs(transaction.amount),
    paymentMethod: transaction.paymentMethod,
    date: transaction.createdAt,
    direction: getOperationDirection(transaction.displayServiceName),
    ad: mapAd(transaction.ad),
  };
}
